module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("byTPN"))).then(() => parcelRequire('9Lwss'));